import { render, staticRenderFns } from "./dashChecklist.vue?vue&type=template&id=a69a9f1a"
import script from "./dashChecklist.vue?vue&type=script&lang=js"
export * from "./dashChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a69a9f1a')) {
      api.createRecord('a69a9f1a', component.options)
    } else {
      api.reload('a69a9f1a', component.options)
    }
    module.hot.accept("./dashChecklist.vue?vue&type=template&id=a69a9f1a", function () {
      api.rerender('a69a9f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/processRam/dashChecklist.vue"
export default component.exports